module.exports = __webpack_public_path__ + "static/media/picasso-1.8024c705.jpeg";